import * as angular from "angular";
import {ReminderSettings} from "../models/reminder-settings.model";
import {VehicleType} from "../../commons/types/vehicle.type";

export class TravelTimeRuleDialogsService {

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  // create(vehicleType: VehicleType, event?) {
  //   return this.$mdDialog.show({
  //     parent: angular.element(document.body),
  //     template: require('./../views/dialogs/create-travel-time-rule-dialog.html').default,
  //     controller: ($scope) => {
  //       $scope.cancel = this.$mdDialog.cancel;
  //
  //       $scope.rule = {
  //         name: undefined,
  //         vehicleType: vehicleType,
  //         travelTimeFactor: undefined
  //       }
  //
  //       // ******************************
  //       // External methods
  //       // ******************************
  //
  //       $scope.submit = (form) => {
  //         if (form) {
  //           form.$setSubmitted(true);
  //
  //           if (form.$valid) {
  //             this.$mdDialog.hide($scope.rule);
  //           }
  //
  //         }
  //       }
  //
  //     },
  //     targetEvent: event,
  //     clickOutsideToClose: true
  //   })
  // }
  //
  // edit(reminderToEdit: ReminderSettings, event) {
  //   return this.$mdDialog.show({
  //     parent: angular.element(document.body),
  //     template: require('./../views/dialogs/edit-reminder-dialog.html').default,
  //     controller: ($scope) => {
  //
  //       $scope.header = 'Edit Document';
  //       $scope.action = 'Edit';
  //       $scope.cancel = this.$mdDialog.cancel;
  //       $scope.reminder = reminderToEdit
  //
  //       // ******************************
  //       // External methods
  //       // ******************************
  //
  //       $scope.submit = (form) => {
  //         if (form) {
  //           form.$setSubmitted(true);
  //
  //           if (form.$valid) {
  //             this.$mdDialog.hide({reminder: $scope.reminder});
  //           }
  //
  //         }
  //       }
  //
  //     },
  //     targetEvent: event,
  //     clickOutsideToClose: true
  //   })
  // }

}

angular
  .module('bringoz.admin.site-preferences')
  .service('travelTimeRuleDialogsService', TravelTimeRuleDialogsService);
